'use strict';

module.exports = function inline(state) {
  var tokens = state.tokens, tok, i, l;

  // Parse inlines
  for (i = 0, l = tokens.length; i < l; i++) {
    tok = tokens[i];
    if (tok.type === 'inline') {
      state.md.inline.parse(tok.content, state.md, state.env, tok.children);
    }
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/markdown-it/lib/rules_core/inline.js
// module id = 2173
// module chunks = 0